import React, { useEffect, useState } from "react";
import Categories from "../Categories/Categories";
import Services from "../Services/Services";
import About from "../About/About";
import InquiryForm from "../InquiryForm/InquiryForm";
import background1 from "../../assets/Images/Background/diamond4.webp";
import background2 from "../../assets/Images/Background/gemstone.webp";
import background3 from "../../assets/Images/Background/Background6.webp";
import background4 from "../../assets/Images/Background/Background1.webp";
import background6 from "../../assets/Images/Background/background2.webp";
import background7 from "../../assets/Images/Background/background3.webp";
import "./HomePage.css";

const backgroundImages = [background1, background2, background3, background4, background6, background7];

const HomePage = () => {
  const [backgroundIndex, setBackgroundIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setBackgroundIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="container">
      <header className="hero-section">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`background-image ${index === backgroundIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
        <h1 className="hero-heading">Welcome to Tanaya Jewel Co. Ltd</h1>
        <p className="hero-subheading">
          We are authorized dealers of diamond and jewellery.
        </p>
      </header>
      <div id="categories">
        <Categories />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="contact">
        <InquiryForm />
      </div>
    </div>
  );
};

export default HomePage;
